import { motion } from "motion/react";
import React from "react";
import { MIN_PANEL_WIDTH } from "./aiChatLayout";
import { panelOverlay, panelResizeHandle, panelShell } from "./chatViewTheme";

/**
 * Animated slide-over shell for the Vanti chat panel (overlay + resizable drawer).
 */
export default function AIChatPanelShell({
	reduceMotion,
	panelWidth,
	maxPanelWidth,
	isResizing,
	onResizeMouseDown,
	onClose,
	children,
}: any) {
	return (
		<div
			className="fixed inset-0 z-50 flex justify-end"
			aria-modal="true"
			role="dialog"
			aria-label="Vanti chat"
		>
			<motion.div
				initial={reduceMotion ? false : { opacity: 0 }}
				animate={{ opacity: 1 }}
				className={`absolute inset-0 ${panelOverlay}`}
				onClick={onClose}
				aria-hidden="true"
			/>
			<motion.div
				initial={reduceMotion ? false : { x: "100%" }}
				animate={{ x: 0 }}
				transition={{ type: "spring", stiffness: 400, damping: 35 }}
				className={`relative flex h-full flex-col ${panelShell}`}
				style={{
					width: panelWidth,
					minWidth: MIN_PANEL_WIDTH,
					maxWidth: maxPanelWidth,
				}}
			>
				<motion.div
					onMouseDown={onResizeMouseDown}
					className={`${panelResizeHandle} ${isResizing ? "bg-brand-purple/40" : ""}`}
					title="Drag to resize"
					aria-hidden
				/>
				{children}
			</motion.div>
		</div>
	);
}
